var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47708 0 0 4.47708 0 10C0 15.5229 4.47708 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47708 15.5229 0 10 0ZM7.55208 14.1448H5.52708V7.62812H7.55208V14.1448ZM6.52708 6.82812C5.8875 6.82812 5.47396 6.375 5.47396 5.81458C5.47396 5.24271 5.9 4.80312 6.55312 4.80312C7.20625 4.80312 7.60625 5.24271 7.61875 5.81458C7.61875 6.375 7.20625 6.82812 6.52708 6.82812ZM14.9479 14.1448H12.9229V10.5333C12.9229 9.69271 12.6292 9.12187 11.8969 9.12187C11.3375 9.12187 11.0052 9.50833 10.8583 9.88021C10.8042 10.0125 10.7906 10.2 10.7906 10.3865V14.1437H8.76458V9.70625C8.76458 8.89271 8.73854 8.2125 8.71146 7.62708H10.4708L10.5635 8.53229H10.6042C10.8708 8.10729 11.524 7.48021 12.6167 7.48021C13.949 7.48021 14.9479 8.37292 14.9479 10.2917V14.1448Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.853d6a88775a360b544770861ec22abe.svg";
export { ForwardRef as ReactComponent };